<form
  *ngIf="parsedFormValues"
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          type="button"
          aria-controls="buttonsLinksAndColors"
        >
          <span class="fs-3">{{
            'configurationOptionModule.buttonsLinksAndColors' | translate
          }}</span>

          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" id="buttonsLinksAndColors">
      <div class="card-body">
        <ng-container *ngIf="form.get('root') as rootFormGroup">
          <fieldset>
            <legend class="h3">
              {{ 'configurationOptionModule.mainColors' | translate }}
            </legend>
            <div class="row">
              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-primary-color')"
              >
                <label class="form-label" [for]="'--bs-primary-color'">
                  {{ 'configurationOptionModule.primaryColor' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-primary-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-secondary-color')"
              >
                <label class="form-label" [for]="'--bs-secondary-color'">
                  {{ 'configurationOptionModule.secondaryColor' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-secondary-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-app-background-color')"
              >
                <label class="form-label" [for]="'--bs-app-background-color'">
                  {{ 'configurationOptionModule.appBackground' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-app-background-color')"
                  type="color"
                />
              </div>
            </div>

            <div class="row mt-2">
              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-primary-text-color')"
              >
                <label class="form-label" [for]="'--bs-primary-text-color'">
                  {{ 'configurationOptionModule.primaryTextColor' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-primary-text-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-secondary-text-color')"
              >
                <label class="form-label" [for]="'--bs-secondary-text-color'">
                  {{
                    'configurationOptionModule.secondaryTextColor' | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-secondary-text-color')"
                  type="color"
                />
              </div>
            </div>
          </fieldset>
          <fieldset class="mt-4">
            <legend class="h3">
              {{ 'configurationOptionModule.notificationColors' | translate }}
            </legend>
            <div class="row">
              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-success-color')"
              >
                <label class="form-label" [for]="'--bs-success-color'">
                  {{ 'configurationOptionModule.success' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-success-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-warning-color')"
              >
                <label class="form-label" [for]="'--bs-warning-color'">
                  {{ 'configurationOptionModule.warnings' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-warning-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-danger-color')"
              >
                <label class="form-label" [for]="'--bs-danger-color'">
                  {{ 'configurationOptionModule.errors' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-danger-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-info-color')"
              >
                <label class="form-label" [for]="'--bs-info-color'">
                  {{ 'configurationOptionModule.info' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-info-color')"
                  type="color"
                />
              </div>
            </div>
          </fieldset>
          <fieldset class="mt-4">
            <legend class="h3">
              {{ 'configurationOptionModule.headerFooterColors' | translate }}
            </legend>
            <div class="row">
              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-brand-bg-header')"
              >
                <label class="form-label" [for]="'--bs-brand-bg-header'">
                  {{
                    'configurationOptionModule.headerBackgroundColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-brand-bg-header')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-primary-header-text-color')"
              >
                <label
                  class="form-label"
                  [for]="'--bs-primary-header-text-color'"
                >
                  {{
                    'configurationOptionModule.primaryHeaderTextColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="
                    rootFormGroup.get('--bs-primary-header-text-color')
                  "
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-brand-bg-footer')"
              >
                <label class="form-label" [for]="'--bs-brand-bg-footer'">
                  {{
                    'configurationOptionModule.footerBackgroundColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-brand-bg-footer')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-secondary-header-text-color')"
              >
                <label
                  class="form-label"
                  [for]="'--bs-secondary-header-text-color'"
                >
                  {{
                    'configurationOptionModule.secondaryHeaderTextColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="
                    rootFormGroup.get('--bs-secondary-header-text-color')
                  "
                  type="color"
                />
              </div>
            </div>
          </fieldset>
        </ng-container>

        <fieldset *ngIf="form.get('btn') as btnFormGroup" class="mt-4">
          <legend class="h3">
            {{ 'configurationOptionModule.commonButtonStyle' | translate }}
          </legend>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnFormGroup.get('--bs-btn-border-radius')"
            >
              <label class="form-label" [for]="'--bs-btn-border-radius'">
                {{ 'configurationOptionModule.buttonBorderRadius' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnFormGroup.get('--bs-btn-border-radius')"
                type="number"
                max="100"
                min="0"
              />

              <p
                class="invalid-feedback"
                role="alert"
                aria-atomic="true"
                *ngIf="
                  btnFormGroup.get('--bs-btn-border-radius').dirty &&
                  btnFormGroup.get('--bs-btn-border-radius').invalid
                "
              >
                <i
                  role="img"
                  class="fas fa-exclamation-circle"
                  aria-hidden="true"
                ></i>
                {{ 'general.value' | translate }}
                {{ 'general.isInvalid' | translate }}
              </p>
            </div>

            <div
              class="col-md-3"
              *ngIf="btnFormGroup.get('--bs-btn-border-width')"
            >
              <label class="form-label" [for]="'--bs-btn-border-width'">
                {{ 'configurationOptionModule.buttonBorderWidth' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnFormGroup.get('--bs-btn-border-width')"
                type="number"
                max="10"
                min="0"
              />

              <p
                class="invalid-feedback"
                role="alert"
                aria-atomic="true"
                *ngIf="
                  btnFormGroup.get('--bs-btn-border-width').dirty &&
                  btnFormGroup.get('--bs-btn-border-width').invalid
                "
              >
                <i
                  role="img"
                  class="fas fa-exclamation-circle"
                  aria-hidden="true"
                ></i>
                {{ 'general.value' | translate }}
                {{ 'general.isInvalid' | translate }}
              </p>
            </div>

            <div
              class="col-md-3"
              *ngIf="btnFormGroup.get('--bs-btn-font-weight')"
            >
              <label class="form-label" [for]="'--bs-btn-font-weight'">
                {{ 'configurationOptionModule.buttonFontWeight' | translate }}
              </label>
              <ng-select
                [items]="boldWeightOptions"
                [formControl]="btnFormGroup.get('--bs-btn-font-weight')"
              >
                <ng-template ng-label-tmp ng-option-tmp let-item="item">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
        </fieldset>

        <fieldset
          *ngIf="form.get('btn-primary') as btnPrimaryFormGroup"
          class="mt-4"
        >
          <legend class="h3">
            {{ 'configurationOptionModule.primaryButtonStyle' | translate }}
          </legend>
          <h4 class="mt-3">
            {{ 'configurationOptionModule.defaultStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnPrimaryFormGroup.get('--bs-btn-color')"
            >
              <label class="form-label" [for]="'--bs-btn-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimaryFormGroup.get('--bs-btn-color')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnPrimaryFormGroup.get('--bs-btn-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimaryFormGroup.get('--bs-btn-bg')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnPrimaryFormGroup.get('--bs-btn-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnPrimaryFormGroup.get('--bs-btn-border-color').value !==
                    'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnPrimaryFormGroup.get('--bs-btn-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-primary"
                  [checked]="
                    btnPrimaryFormGroup.get('--bs-btn-border-color').value ==
                    'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-border-color',
                      'btn-primary',
                      $event
                    )
                  "
                />
                <label class="form-check-label" for="checkbox-btn-primary">
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>

          <h4 class="mt-3">
            {{ 'configurationOptionModule.hoverActiveStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnPrimaryFormGroup.get('--bs-btn-hover-color')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimaryFormGroup.get('--bs-btn-hover-color')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnPrimaryFormGroup.get('--bs-btn-hover-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimaryFormGroup.get('--bs-btn-hover-bg')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnPrimaryFormGroup.get('--bs-btn-hover-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-hover-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnPrimaryFormGroup.get('--bs-btn-hover-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnPrimaryFormGroup.get('--bs-btn-hover-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-primary-hover"
                  [checked]="
                    btnPrimaryFormGroup.get('--bs-btn-hover-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-hover-border-color',
                      'btn-primary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-primary-hover"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- primary soft -->
        <fieldset
          *ngIf="form.get('btn-soft-primary') as btnPrimarySoftFormGroup"
          class="mt-4"
        >
          <legend class="h3">
            {{ 'configurationOptionModule.primarySoftButtonStyle' | translate }}
          </legend>
          <h4 class="mt-3">
            {{ 'configurationOptionModule.defaultStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnPrimarySoftFormGroup.get('--bs-btn-color')"
            >
              <label class="form-label" [for]="'--bs-btn-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimarySoftFormGroup.get('--bs-btn-color')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnPrimarySoftFormGroup.get('--bs-btn-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimarySoftFormGroup.get('--bs-btn-bg')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnPrimarySoftFormGroup.get('--bs-btn-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnPrimarySoftFormGroup.get('--bs-btn-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnPrimarySoftFormGroup.get('--bs-btn-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-soft-primary"
                  [checked]="
                    btnPrimarySoftFormGroup.get('--bs-btn-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-border-color',
                      'btn-soft-primary',
                      $event
                    )
                  "
                />
                <label class="form-check-label" for="checkbox-btn-soft-primary">
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>

          <h4 class="mt-3">
            {{ 'configurationOptionModule.hoverActiveStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnPrimarySoftFormGroup.get('--bs-btn-hover-color')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnPrimarySoftFormGroup.get('--bs-btn-hover-color')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnPrimarySoftFormGroup.get('--bs-btn-hover-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnPrimarySoftFormGroup.get('--bs-btn-hover-bg')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnPrimarySoftFormGroup.get('--bs-btn-hover-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-hover-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnPrimarySoftFormGroup.get('--bs-btn-hover-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnPrimarySoftFormGroup.get('--bs-btn-hover-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-soft-primary-hover"
                  [checked]="
                    btnPrimarySoftFormGroup.get('--bs-btn-hover-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-hover-border-color',
                      'btn-soft-primary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-soft-primary-hover"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- header button -->
        <fieldset
          *ngIf="
            form.get(
              'btn-header-soft-secondary'
            ) as btnHeaderSoftSecondaryFormGroup
          "
          class="mt-4"
        >
          <legend class="h3">
            {{ 'configurationOptionModule.headerButtonStyle' | translate }}
          </legend>
          <h4 class="mt-3">
            {{ 'configurationOptionModule.defaultStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnHeaderSoftSecondaryFormGroup.get('--bs-btn-color')"
            >
              <label class="form-label" [for]="'--bs-btn-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnHeaderSoftSecondaryFormGroup.get('--bs-btn-color')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnHeaderSoftSecondaryFormGroup.get('--bs-btn-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnHeaderSoftSecondaryFormGroup.get('--bs-btn-bg')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnHeaderSoftSecondaryFormGroup.get('--bs-btn-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnHeaderSoftSecondaryFormGroup.get('--bs-btn-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnHeaderSoftSecondaryFormGroup.get('--bs-btn-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-header-soft-secondary"
                  [checked]="
                    btnHeaderSoftSecondaryFormGroup.get('--bs-btn-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-border-color',
                      'btn-header-soft-secondary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-header-soft-secondary"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>

          <h4 class="mt-3">
            {{ 'configurationOptionModule.hoverActiveStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="
                btnHeaderSoftSecondaryFormGroup.get('--bs-btn-hover-color')
              "
            >
              <label class="form-label" [for]="'--bs-btn-hover-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnHeaderSoftSecondaryFormGroup.get('--bs-btn-hover-color')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnHeaderSoftSecondaryFormGroup.get('--bs-btn-hover-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnHeaderSoftSecondaryFormGroup.get('--bs-btn-hover-bg')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnHeaderSoftSecondaryFormGroup.get(
                  '--bs-btn-hover-border-color'
                ) && form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-hover-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>

              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnHeaderSoftSecondaryFormGroup.get(
                      '--bs-btn-hover-border-color'
                    ).value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnHeaderSoftSecondaryFormGroup.get(
                      '--bs-btn-hover-border-color'
                    )
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-header-soft-secondary-hover"
                  [checked]="
                    btnHeaderSoftSecondaryFormGroup.get(
                      '--bs-btn-hover-border-color'
                    ).value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-hover-border-color',
                      'btn-header-soft-secondary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-header-soft-secondary-hover"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>
        </fieldset>

        <!-- secondary soft -->
        <fieldset
          *ngIf="form.get('btn-soft-secondary') as btnSoftSecondaryFormGroup"
          class="mt-4"
        >
          <legend class="h3">
            {{
              'configurationOptionModule.secondarySoftButtonStyle' | translate
            }}
          </legend>
          <h4 class="mt-3">
            {{ 'configurationOptionModule.defaultStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnSoftSecondaryFormGroup.get('--bs-btn-color')"
            >
              <label class="form-label" [for]="'--bs-btn-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnSoftSecondaryFormGroup.get('--bs-btn-color')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnSoftSecondaryFormGroup.get('--bs-btn-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="btnSoftSecondaryFormGroup.get('--bs-btn-bg')"
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnSoftSecondaryFormGroup.get('--bs-btn-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>
              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnSoftSecondaryFormGroup.get('--bs-btn-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnSoftSecondaryFormGroup.get('--bs-btn-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-soft-secondary"
                  [checked]="
                    btnSoftSecondaryFormGroup.get('--bs-btn-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-border-color',
                      'btn-soft-secondary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-soft-secondary"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>

          <h4 class="mt-3">
            {{ 'configurationOptionModule.hoverActiveStyle' | translate }}
          </h4>
          <div class="row">
            <div
              class="col-md-3"
              *ngIf="btnSoftSecondaryFormGroup.get('--bs-btn-hover-color')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-color'">
                {{ 'configurationOptionModule.textColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnSoftSecondaryFormGroup.get('--bs-btn-hover-color')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="btnSoftSecondaryFormGroup.get('--bs-btn-hover-bg')"
            >
              <label class="form-label" [for]="'--bs-btn-hover-bg'">
                {{ 'configurationOptionModule.backgroundColor' | translate }}
              </label>
              <input
                class="form-control"
                [formControl]="
                  btnSoftSecondaryFormGroup.get('--bs-btn-hover-bg')
                "
                type="color"
              />
            </div>

            <div
              class="col-md-3"
              *ngIf="
                btnSoftSecondaryFormGroup.get('--bs-btn-hover-border-color') &&
                form.get('btn').get('--bs-btn-border-width').value > 0
              "
            >
              <label class="form-label" [for]="'--bs-btn-hover-border-color'">
                {{ 'configurationOptionModule.borderColor' | translate }}
              </label>
              <div class="d-flex align-items-center gap-3">
                <input
                  *ngIf="
                    btnSoftSecondaryFormGroup.get('--bs-btn-hover-border-color')
                      .value !== 'transparent'
                  "
                  class="form-control"
                  [formControl]="
                    btnSoftSecondaryFormGroup.get('--bs-btn-hover-border-color')
                  "
                  type="color"
                />
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="checkbox-btn-soft-secondary-hover"
                  [checked]="
                    btnSoftSecondaryFormGroup.get('--bs-btn-hover-border-color')
                      .value == 'transparent'
                  "
                  (change)="
                    toggleColorInput(
                      '--bs-btn-hover-border-color',
                      'btn-soft-secondary',
                      $event
                    )
                  "
                />
                <label
                  class="form-check-label"
                  for="checkbox-btn-soft-secondary-hover"
                >
                  {{ 'configurationOptionModule.transparent' | translate }}
                </label>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="mt-4">
          <ng-container *ngIf="form.get('root') as rootFormGroup">
            <legend class="h3">
              {{ 'configurationOptionModule.linksAndNavigation' | translate }}
            </legend>
            <h4 class="mt-3">
              {{ 'configurationOptionModule.linksColors' | translate }}
            </h4>
            <div class="row">
              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-link-color')"
              >
                <label class="form-label" [for]="'--bs-link-color'">
                  {{ 'configurationOptionModule.defaultLinkColor' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-link-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="rootFormGroup.get('--bs-link-hover-color')"
              >
                <label class="form-label" [for]="'--bs-link-hover-color'">
                  {{ 'configurationOptionModule.linkHoverColor' | translate }}
                </label>
                <input
                  class="form-control"
                  [formControl]="rootFormGroup.get('--bs-link-hover-color')"
                  type="color"
                />
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="form.get('navbar') as navbarFormGroup">
            <legend class="h4">
              {{ 'configurationOptionModule.navigationLinks' | translate }}
            </legend>
            <div class="row">
              <div
                class="col-md-3"
                *ngIf="navbarFormGroup.get('--bs-nav-link-color')"
              >
                <label class="form-label" [for]="'--bs-nav-link-color'">
                  {{
                    'configurationOptionModule.defaultNavigationColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="navbarFormGroup.get('--bs-nav-link-color')"
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="navbarFormGroup.get('--bs-nav-link-hover-color')"
              >
                <label class="form-label" [for]="'--bs-nav-link-hover-color'">
                  {{
                    'configurationOptionModule.hoverNavigationColor' | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="
                    navbarFormGroup.get('--bs-nav-link-hover-color')
                  "
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="navbarFormGroup.get('--bs-nav-link-active-color')"
              >
                <label class="form-label" [for]="'--bs-nav-link-active-color'">
                  {{
                    'configurationOptionModule.activeNavigationColor'
                      | translate
                  }}
                </label>
                <input
                  class="form-control"
                  [formControl]="
                    navbarFormGroup.get('--bs-nav-link-active-color')
                  "
                  type="color"
                />
              </div>

              <div
                class="col-md-3"
                *ngIf="navbarFormGroup.get('--bs-nav-link-font-weight')"
              >
                <label class="form-label" [for]="'--bs-nav-link-font-weight'">
                  {{
                    'configurationOptionModule.navigationFontWeight' | translate
                  }}
                </label>

                <ng-select
                  [items]="boldWeightOptions"
                  [formControl]="
                    navbarFormGroup.get('--bs-nav-link-font-weight')
                  "
                >
                  <ng-template ng-label-tmp ng-option-tmp let-item="item">
                    {{ item.name }}
                  </ng-template>
                </ng-select>
              </div>
            </div>
          </ng-container>
        </fieldset>
      </div>

      <div
        class="card-footer form-footer sticky-bottom justify-content-between"
      >
        <div
          class="spinner-border"
          role="status"
          *ngIf="(isLoading$ | async) || isloadingFromParentPage"
          attr.aria-label="{{ 'general.loading' | translate }}"
        >
        </div>

        <ng-container *ngIf="!(isLoading$ | async) && !isloadingFromParentPage">
          <button
            type="button"
            (click)="resetToDefault()"
            class="btn btn-soft-primary"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'configurationOptionModule.resetToDefault' | translate }}
          </button>

          <button
            class="btn btn-primary"
            type="submit"
            [canSee]="[accessRights.Settings_write]"
            [canSee]="[accessRights.ConfigurationOptions_write]"
          >
            {{ 'general.save' | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </section>

  <!-- <div class="d-flex justify-content-end pt-3">
    <div
      class="spinner-border"
      role="status"
      *ngIf="(isLoading$ | async) || isloadingFromParentPage"
       attr.aria-label="{{ 'general.loading' | translate }}"
    >
      
    </div>
    <button
      class="btn btn-primary"
      type="submit"
      [canSee]="[accessRights.Settings_write]"
      [canSee]="[accessRights.ConfigurationOptions_write]"
    >
      {{ 'general.save' | translate }}
    </button>
  </div> -->
  <!-- End Card -->
</form>
